// extracted by mini-css-extract-plugin
module.exports = {"container":"az_mVc","promptText":"az_nVc","promptLabel":"az_oVc","closeButton":"az_pVc","srOnly":"az_qVc"};